import React from 'react';
import Categories from '../components/Categories';

const CategoriesPage = () => (
  <div className="page-body">
    <Categories />
  </div>
);

export default CategoriesPage;
